<!-- HEADER --><!-- HEADER -->
<app-header
  [class.show-background]="showToolbar"
  color="transparent"
  class="header-override"></app-header>

<!-- CONTENT -->
<ion-content
  class="padded"
  [scrollEvents]="true"
  (ionScroll)="onScroll($event)">
  <div class="hero">
    <app-img-format
      *ngIf="featuredImage"
      [src]="featuredImage"
      [alt]="title"
      [aspectRatio]="'16:9'"
      [disableLazyLoad]="true"></app-img-format>
    <ion-text color="light">
      <h1 class="hero-title">Sitemap</h1>
    </ion-text>
  </div>

  <section>
    <div *ngFor="let page of pages" class="page-list">
      <ng-container *ngIf="page.children; else topLevelItem">
        <h2>{{ page.title }}</h2>
        <ng-container *ngFor="let child of page.children">
          <ion-item>
            <ion-icon
              name="chevron-forward-circle-outline"
              slot="start"
              color="dark"></ion-icon>
            <a (click)="linkToPage(child)" class="page-link"
              >{{ child.title }}</a
            >
          </ion-item>
        </ng-container>
      </ng-container>
      <ng-template #topLevelItem>
        <h2>{{ page.title }}</h2>
        <ion-item>
          <ion-icon
            name="chevron-forward-circle-outline"
            slot="start"
            color="dark"></ion-icon>
          <a (click)="linkToPage(page)" class="page-link"
            >{{ page.title }} Page</a
          >
        </ion-item>
      </ng-template>
    </div>
  </section>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
